import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeToggle } from "@/components/theme-toggle";
import { LanguageSwitcher } from "@/components/language-switcher";
import { Button } from "@/components/ui/button";
import { useBrand } from "@/hooks/use-brand";

export default function MarketingHeader() {
  const { t } = useTranslation();
  const brand = useBrand();

  const links = [
    { to: "/features", label: t("nav.features") },
    { to: "/pricing", label: t("nav.pricing") },
    { to: "/customers", label: t("nav.stories") },
    { to: "/pricing#faq", label: t("nav.faq") },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 glass" data-testid="marketing-header">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="h-7 w-7 rounded-md bg-primary text-primary-foreground grid place-items-center font-display font-bold text-sm">A</span>
          <span className="font-display text-base sm:text-lg tracking-tight">{brand.brand}</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className="text-muted-foreground hover:text-foreground transition-colors"
              data-testid={`nav-${l.to.replace(/\//g, "")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <ThemeToggle />
          <Link to="/login" className="hidden sm:inline-block">
            <Button variant="ghost" size="sm" className="rounded-full" data-testid="login-btn">{t("nav.signIn")}</Button>
          </Link>
          <Link to="/signup">
            <Button size="sm" className="rounded-full" data-testid="signup-btn">{t("nav.startFree")}</Button>
          </Link>
        </div>
      </div>
    </header>
  );
}
